/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:16:46
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare खोलें",
    name2: "रिजर्वेशन करें",
    name3: "Carlcare से, आप अपना ऑर्डर किसी भी समय देख सकते हैं।",
    name4: "",
    name5: "दाईं ओर स्लाइड करें",
    name6: "सत्यापन पूरा हुआ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "App",
    name81: "Website",
    name82: "Hotline",
    name83: "WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
    name86: "Book Carlcare",
    name87: "Home Service",
    name88: " Today!",
  },
  order: {
    name1: "उपकरण मॉडल चुनें",
    name2: "त्रुटी विवरण:",
    name3: "सेवा स्टोर चुनने के लिए टैप करें",
    name4: "सेवा स्टोर:",
    name5: "रिजर्वेशन समय:",
    name6: "कृपया आपके उपकरण में आने वाली समस्या के बारे में विस्तार से बताएं!",
    name7: "आने का समय चुनने के लिए टैप करें",
    name8: "कृपया अपना सही संपर्क वर्णन दर्ज करें ताकि हम आप तक पहुँच सकें",
    name9: "उपलब्ध आरक्षित समय निम्नलिखित है",
    name10: "कृपया अपना फ़ोन नंबर प्रविष्ट करें",
    name11: "मूल्य:",
    name12: "निजी जानकारी:",
    name13: "कृपया अपना नाम प्रविष्ट करें",
    name14: "सबमिट करें",
    name15: "रद्द करें",
    name16: "ठीक है",
  },
  shops: {
    name1: "आपके द्वारा चुने गए ब्रांड के आधार पर, निम्न दुकानें आपको सेवा प्रदान कर सकती हैं!",
    name2: "जल्द ही ज्यादा रिटेल स्टोर में आने वाला है! हमारे साथ बने रहें!",
  },
  price: {
    name1: "ब्रांड",
    name2: "मॉडल",
    name3: "आइटम",
    name4: "मूल्य:",
    name5: "फ़्रैंडली रिमाइंडर:",
    name6: "ये कीमत केवल संदर्भ के लिए है, और वास्तविक कीमत आपके उपकरण की स्थिति पर आधारित है।",
    name7: "अगर यहाँ कोई विशेष चिह्न नहीं है, तो प्राइज़ यूनिट लोकल करेंसी यूनिट है।",
    name8: "क्षमा करें! वर्तमान क्षेत्र में कोई भी कीमत की जानकारी उपलब्ध नहीं है।",
    name11:"श्रम लागत",
    name12:"कुल कीमत",
    name13: "5. यदि श्रम लागत \"/\" है, तो इसका मतलब है कि श्रम लागत के बारे में स्टोर से परामर्श करने की आवश्यकता है।",
    item_main_board: "मेनबोर्ड",
    item_screen_frame: "स्क्रीन (फ़्रेम)",
    item_screen_screen_frame: "सेकंडरी स्क्रीन (फ़्रेम)",
    item_touch_screen: "टच स्क्रीन",
    item_camera: "कैमरा",
    item_fixed_focus_camera: "फ़िक्स्ड फ़ोकस कैमरा",
    item_auto_focus_camera: "स्वतः फ़ोकस कैमरा",
    item_screen: "स्क्रीन",
    item_secondary_screen: "सेकंडरी स्क्रीन",
    item_fingerprint_module: "फिंगरप्रिंट मॉड्यूल",
    item_speaker: "स्‍पीकर",
    item_receiver: "प्राप्तकर्ता",
    item_small_board: "छोटा बोर्ड",
    item_battery_cover: "बैटरी का कवर",
    item_battery: "बैटरी",
    item_charger: "चार्जर",
    item_usb_cable: "USB केबल",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "कोई आकड़ा उपलब्ध नहीं है",
    name2: "सेवा प्रदाता:",
    name3: "सेवा ब्रांड:",
    name4: "टेलीफोन:",
    name5: "ऑर्डर की मात्रा:",
    name6: "सेवा रेटिंग",
    name7: "सेवा परिवेश:",
    name8: "सेवा अभिवृत्ति:",
    name9: "सेवा कार्यक्षमता:",
    name10: "सेवा गुणवत्ता:",
    name11: "ग्राहक मूल्यांकन",
    name12:"से",
    name13:"बंद हो गया",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare खोलें",
    name1: "कृपया आरक्षण की जानकारी का स्क्रीनशॉट लें और इसे एक रसीद के तौर पर सहेजें ताकि पसंद की सेवा को एक्सेस किया जा सके।",
    name2: "सफलतापूर्वक सबमिट कर दिया है",
    name3: "1. डेटा को साफ़ करें",
    name4: "कृपया अपने फ़ोन पर पहले ही ज़रूरी निजी डेटा का बैक अप लें",
    name5: "2. पावर-ऑन पासवर्ड को अक्षम करें",
    name6: "सर्विस स्टोर पर जाने से पहले, कृपया:",
    name7: "सेवा स्टोर:",
    name8: "रिजर्वेशन समय:",
    name9: "त्रुटी विवरण:",
    name10: "उपकरण मॉडल:",
    name11: "ऑर्डर नंबर:",
    name12: "आर्डर जानकारी",
  },
  title: {
    
    name1: "निम्नलिखित देशों का समर्थन करता है:",
    name2: "मॉडल चुनें",
    name3: "आरक्षण",
    name4: "सेवा स्टोर विवरण",
    name5: "सेवा स्टोर चुनें",
  },
  error: {
    
    name1: "कोई डेटा नहीं। कृपया अपनी मरम्मत की जानकारी देखें",
    name2: "ज्यादा मदद की जरूरत है? कृपया हमसे संपर्क करें।",
    name3: "माफ करें, वर्तमान क्षेत्र में कोई Carlcare केंद्र नहीं है।",
    name4: "कृपया सबसे पहले एक सेवा केंद्र सूची चुनें",
    name5: "विफल रहा",
    name6: "कृपया सबसे पहले उपकरण मॉडल चुनें",
    name7: "विवरण",
    name8: "कृपया अपनी आवश्यकताओं के बार में विस्तार से बताएं",
    name9: "",
  },
  add1:{
    "name0": "hi",
    "name1": "आपके ऑर्डर की पुष्टि हो गई है। हमें आपके आगमन का इंतज़ार रहता है।",
    "name2": "आप नगर चुनें",
    "name3": "कृपया %1$sअंक का फ़ोन नंबर डालें।",
    "name4": "सप्ताह के दिनों के घंटे",
    "name5": "सोमवार",
    "name6": "मंगलवार",
    "name7": "बुधवार",
    "name8": "गुरूवार",
    "name9": "शुक्रवार",
    "name10": "शनिवार",
    "name11": "रविवार",
    "name12": "देश का नाम डालें और खोजें"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "अन्य",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
    "name31": "पिकअप और ड्रॉप सुविधा",
  },
  coupons: {
    name1:"Coupons",
    name2:"पुनर्निर्देशित करने के लिए टैप करें",
    name3:"ऑर्डर को रेट करने के लिए, Carlcare ऐप खोलें",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"सेवा चुनें",
    name7:"मुफ़्त सफ़ाई",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "गलत जानकारी",
    "cancelReason1": "समय पर नहीं पहुंच सकता",
    "cancelReason2": "डुप्लिकेट ऑर्डर/मेरा ऑर्डर नहीं",
    "cancelReason3": "खराबी दोबारा नहीं होती",
    "cancelReason4": "सिर्फ परीक्षण/पूछताछ/घटना के लिए/…",
    "cancelReason5": "अधिक कीमत",
    "cancelReason6": "सामग्री की कमी",
    "cancelReason7": "अंतर करने वाली कोई सेवाएं नहीं",
    "cancelReason8": "स्टोर बहुत दूर है",
    "cancelReason9": "स्टोर बंद है",
    "cancelReason10": "खराब सेवा का रवैया",
    "cancelReason11": "अन्य ब्रांड के लिए रीप्लेसमेंट/मरम्मत",
    "cancelReason12": "स्‍टोर नहीं मिल सका",
    "cancelReason13": "अन्य",
    "cancelOrder": "ऑर्डर रद्द करें",
    "reason_dialog_title": "कृपया हमें रद्द करने का कारण बताएं",
    "Cancel": "रद्द",
    "OK": "ठीक",
    "name1": "पुष्टिकरण कोड प्रविष्ट करें",
    "name2": "अवैध पुष्टिकरण कोड",
    "repair_reservation_detail_canceled": "यह ऑर्डर रद्द कर दिया गया है!",
    "purchase_cancel_dialog_content": "क्या आप ऑर्डर रद्द करने के लिए कन्फ़र्म करना चाहते हैं?",
    "yes": "हां",
    "no": "नहीं"
}
};
